import { useContext } from 'react';

import { AgentSettingsContext } from 'providers/AgentSettingsProvider';

const useAgentSettings = () => {
  return useContext(AgentSettingsContext);
};

export default useAgentSettings;
